"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = require("@coastomizer/component");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Text = /*#__PURE__*/function (_Coastomizer) {
  _inherits(Text, _Coastomizer);
  var _super = _createSuper(Text);
  function Text(props) {
    var _this;
    _classCallCheck(this, Text);
    _this = _super.call(this, props);
    _this.base = "text";
    if (props.as) {
      _this.base = props.as;
    }
    _this.defaultRules = [{
      wordBreak: "break-word"
    }];
    _this.complexRules = {
      paragraph: function paragraph() {
        return [{
          lineHeight: "1.5rem"
        }];
      },
      a: function a() {
        return [{
          cursor: "pointer"
        }];
      },
      h1: function h1() {
        return [{
          fontSize: "5vmin",
          fontWeight: "bold"
        }];
      },
      h2: function h2() {
        return [{
          fontSize: "4vmin",
          fontWeight: "bold"
        }];
      },
      h3: function h3() {
        return [{
          fontSize: "3.5vmin",
          fontWeight: "bold"
        }];
      },
      h4: function h4() {
        return [{
          fontSize: "3vmin",
          fontWeight: "bold"
        }];
      },
      h5: function h5() {
        return [{
          fontSize: "21px",
          fontWeight: 500
        }];
      },
      h6: function h6() {
        return [{
          fontSize: "18px",
          fontWeight: 500
        }];
      },
      regular: function regular() {
        return [{
          fontSize: "16px",
          fontWeight: 400
        }];
      },
      small: function small() {
        return [{
          fontSize: "12px"
        }];
      },
      bold: function bold() {
        return [{
          fontWeight: "bold"
        }];
      },
      italic: function italic() {
        return [{
          fontStyle: "italic"
        }];
      }
    };
    _this.mapAttributesToRules = {
      paragraph: "paragraph",
      size: "fontSize",
      color: "color",
      align: "textAlign",
      h1: "h1",
      h2: "h2",
      h3: "h3",
      h4: "h4",
      h5: "h5",
      h6: "h6",
      regular: "regular",
      bold: "bold",
      italic: "italic",
      small: "small",
      a: "a"
    };
    return _this;
  }
  return _createClass(Text);
}(_component.Coastomizer);
Text.propTypes = {
  h1: _propTypes["default"].bool,
  h2: _propTypes["default"].bool,
  h3: _propTypes["default"].bool,
  h4: _propTypes["default"].bool,
  h5: _propTypes["default"].bool,
  h6: _propTypes["default"].bool,
  paragraph: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  bold: _propTypes["default"].bool,
  italic: _propTypes["default"].bool,
  color: _propTypes["default"].string,
  size: _propTypes["default"].string,
  align: _propTypes["default"].string,
  customStyle: _propTypes["default"].arrayOf(_propTypes["default"].object),
  innerRef: _propTypes["default"].any
};
var _default = Text;
exports["default"] = _default;